import { useContext, useEffect, useState } from "react";
import { getData } from "src/actions/getData";
import MiniInfoButton from "src/components/MiniInfoButton";
import PageHeader from "src/components/PageHeader";
import Table from "src/components/Table";
import { numberWithCommas } from "src/utils/thousandSeprator";
import { FiEye } from "react-icons/fi";
import { TbReload } from "react-icons/tb";
import { get } from "src/services/HttpClient";
import ModalHeader from "src/components/Modal/ModalHeader";
import ModalBody from "src/components/Modal/ModalBody";
import ModalFooter from "src/components/Modal/ModalFooter";
import Modal from "src/components/Modal/Modal";
// import Refund from "./components/Refund";

var moment = require("jalali-moment");

export default function Refunds() {
    const [data, setData] = useState();
    const [loading, setLoading] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);
    const [selectedRefund, setSelectedRefund] = useState(null);

    useEffect(() => {
        // getRefundData();

        const controller = new AbortController(); // برای لغو درخواست
        const signal = controller.signal;

        getData(setData, "/refunds", {}, signal)

        return () => {
            controller.abort();
        };
    }, []);

    const getRefundData = async () => {
        setLoading(true);
        try {
            // اینجا باید API endpoint واقعی جایگزین شود
            const result = await get("/seller/inbounds");
            if (result?.success) {
                setData(result.body);
            }
        } catch (error) {
            console.error("Error fetching inbound data:", error);
        } finally {
            setLoading(false);
        }
    };

    const getStatusColor = (status) => {
        switch (status) {
            case "pending":
                return "#facc15";
            case "delivered":
                return "#22c55e";
            case "partial":
                return "#d54a3b";
            case "cancelled":
                return "#ef4444";
            default:
                return "#6b7280";
        }
    };

    const getStatusText = (status) => {
        switch (status) {
            case "pending":
                return "در انتظار";
            case "delivered":
                return "تحویل شده";
            case "partial":
                return "کسری دارد";
            case "cancelled":
                return "لغو شده";
            default:
                return "نامشخص";
        }
    };

    const columns = [
        {
            id: "id",
            cell: (info) => info.getValue(),
            header: "شناسه",
        },
        {
            id: "user",
            cell: (info) => info.getValue() ? info.getValue().fullName : "---",
            header: "تامین کننده",
        },
        {
            id: "status",
            cell: (info) => (
                <MiniInfoButton
                    text={getStatusText(info.getValue())}
                    backgroundColor={getStatusColor(info.getValue())}
                />
            ),
            header: "وضعیت",
        },
        {
            id: "createdAt",
            cell: (info) => (
                <>
                    {info.getValue()
                        ? moment
                            .from(info.getValue())
                            .locale("fa")
                            .format("jYYYY/jMM/jDD HH:mm")
                        : "---"}
                </>
            ),
            header: "تاریخ ایجاد",
        },
        {
            id: "deliveredAt",
            cell: (info) => (
                <>
                    {info.getValue()
                        ? moment
                            .from(info.getValue())
                            .locale("fa")
                            .format("jYYYY/jMM/jDD HH:mm")
                        : "---"}
                </>
            ),
            header: "تاریخ تحویل",
        },
        {
            id: "totalRefundQuantity",
            cell: (info) => {
                const products = info.row.original.refundproducts;
                if (!products) return 0;
                return products.reduce((sum, product) => sum + (product.refundQuantity || 0), 0);
            },
            header: "مجموع تعداد محموله",
        },
        {
            id: "totalDeliveredQuantity",
            cell: (info) => {
                const products = info.row.original.refundproducts;
                if (!products) return 0;
                return products.reduce((sum, product) => sum + (product.deliveredQuantity || 0), 0);
            },
            header: "مجموع تعداد تحویل",
        },
        {
            id: "actions",
            cell: (info) => (
                <div className="flex gap-2">
                    <div
                        className="cursor-pointer hover:bg-gray-100 hover:text-gray-600 transition-all ease-in-out duration-300 bg-gray-50 dark:bg-gray-700 text-gray-400 p-2 rounded-lg"
                        onClick={() => {
                            setSelectedRefund(info.row.original);
                            setModalOpen(true);
                        }}
                        title="مشاهده جزئیات"
                    >
                        <FiEye className="text-blue-500" />
                    </div>
                </div>
            ),
            header: "عملیات",
            enableColumnFilter: false,
        },
    ];


    return (
        <>
            <PageHeader
                title="مدیریت مرجوعی‌ها"
                btnTitle="بروزرسانی"
                handleClick={getRefundData}
                isBtnLoading={loading}
                btnIcon={<TbReload className="ml-1" size="22" />}
            />

            <Table
                columns={columns}
                data={data}
                CSVExportPermission="exportSellerRefund"
                tableName="seller-inbound"
            />

            <Modal isOpen={modalOpen} toggle={() => setModalOpen(false)} width={700}>
                <ModalHeader toggle={() => setModalOpen(false)}>
                    جزییات محصولات ورودی
                </ModalHeader>
                <ModalBody>
                    <div className="p-4">
                        {selectedRefund && selectedRefund.refundproducts && selectedRefund.refundproducts.length > 0 ? (
                            <div className="flex flex-col gap-[10px]">
                                {selectedRefund.refundproducts.map((product, idx) => (
                                    <div key={idx} className={`flex flex-col md:flex-row items-center gap-4 border border-gray-200 rounded-lg p-2 ${(parseInt(product.deliveredQuantity ?? 0) < parseInt(product.inboundQuantity ?? 0) && selectedRefund.status != "pending") ? "!bg-red-100" : ""}`}>
                                        <img
                                            className="w-[70px] h-[70px] object-cover rounded-lg border border-gray-100"
                                            src={product.image}
                                            alt={product.name}
                                        />
                                        <div className="flex-1 flex flex-col gap-1">
                                            <div className="flex flex-col flex-wrap gap-3">
                                                <span className="font-semibold text-sm">{product.name}</span>
                                                <div className="flex gap-4">
                                                    <span className="text-xs text-gray-500">SKU: {product.sku}</span>
                                                    <span className="text-xs text-gray-500">شماره سفارش: {product.orderId}</span>
                                                </div>
                                            </div>
                                            <div className="flex flex-wrap gap-4 mt-2">
                                                <span className="text-xs text-gray-600">تعداد مرجوعی: <b>{product.refundQuantity}</b></span>
                                                <span className="text-xs text-gray-600">تعداد تحویل: <b>{product.deliveredQuantity ?? 0}</b></span>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <div className="text-center py-8">محصولی وجود ندارد.</div>
                        )}
                        <div className="flex flex-col gap-4 mt-4">
                            {
                                selectedRefund?.sellerComment
                                &&
                                <div className="flex flex-col gap-2">
                                    <span>توضیحات فروشنده</span>
                                    <p className="bg-gray-50 p-2 rounded-xl">
                                        {selectedRefund?.sellerComment}
                                    </p>
                                </div>
                            }
                            {
                                selectedRefund?.warehouseComment
                                &&
                                <div className="flex flex-col gap-2">
                                    <span>توضیحات انباردار</span>
                                    <p className="bg-gray-50 p-2 rounded-xl">
                                        {selectedRefund?.warehouseComment}
                                    </p>
                                </div>
                            }
                        </div>
                    </div>
                </ModalBody>
            </Modal>
        </>
    );
}
